"use client";

import { motion } from "framer-motion";
import { Headphones, Home, MessageSquare, Sparkles, TrendingUp } from "lucide-react";
import { useLocale } from "next-intl";

const scrollTo = (id: string) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "center" });
};

export default function AIToolsHub() {
  const locale = useLocale();
  const isAr = locale === "ar";

  const tools = [
    { id: "ai-day", icon: Home, ar: "عِش فيه يوماً", en: "Live a day", desc: isAr ? "جولة سينمائية" : "Cinematic tour" },
    { id: "ai-ask", icon: MessageSquare, ar: "اسأل العقار", en: "Ask property", desc: isAr ? "محادثة ذكية" : "Smart chat" },
    { id: "ai-audio", icon: Headphones, ar: "ملخص صوتي", en: "Audio summary", desc: isAr ? "استمع للملخص" : "Listen" },
    { id: "ai-fair", icon: TrendingUp, ar: "السعر العادل", en: "Fair price", desc: isAr ? "تحقق من السعر" : "Check price" },

  ];

  return (
    <div dir={isAr ? "rtl" : "ltr"} className="my-8 relative overflow-hidden rounded-[28px] bg-gradient-to-br from-[#0a2a6e] via-[#0d3589] to-[#071f52] p-6 sm:p-7 text-white">
      <div className="pointer-events-none absolute -top-14 -left-10 size-56 rounded-full bg-amber-400/15 blur-3xl" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-300/70 to-transparent" />

      <div className="relative flex items-center gap-3 mb-5">
        <div className="size-12 rounded-2xl bg-gradient-to-br from-amber-300 to-amber-500 flex items-center justify-center text-[#0d3589] shadow-lg">
          <Sparkles size={24} />
        </div>
        <div>
          <h3 className="font-black text-xl flex items-center gap-1.5">
            {isAr ? "مساعد SNA الذكي لهذا العقار" : "SNA AI for this property"}
          </h3>
          <p className="text-sm text-blue-100/70">
            {isAr ? "كل أدوات الذكاء الاصطناعي في مكان واحد" : "All AI tools in one place"}
          </p>
        </div>
      </div>

      <div className="relative grid grid-cols-2 sm:grid-cols-4 gap-3">
        {tools.map((t, i) => {
          const Icon = t.icon;
          return (
            <motion.button
              key={t.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.06 }}
              onClick={() => scrollTo(t.id)}
              className="group flex flex-col items-center gap-2 rounded-2xl bg-white/10 hover:bg-white/20 ring-1 ring-white/15 hover:ring-amber-300/40 p-4 transition-all active:scale-95"
            >
              <span className="size-11 rounded-xl bg-white/10 group-hover:bg-amber-300 group-hover:text-[#0d3589] text-amber-300 flex items-center justify-center transition-all">
                <Icon size={20} />
              </span>
              <span className="font-bold text-sm">{isAr ? t.ar : t.en}</span>
              <span className="text-[11px] text-blue-100/60">{t.desc}</span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
